// SPDX-License-Identifier: AGPL-3.0-or-later

export const API_CODE_VERSION = 1;
export const DEFAULT_API_VERSION = 1;
export const FLUXERBOT_ID = '0';
export const ME = '@me';
export const FAVORITES_GUILD_ID = '@favorites';
export const DEFAULT_ACCENT_COLOR = '#4641D9';
